import React, { Fragment, useState } from 'react';
import { Button, useRecordContext } from 'react-admin';
import ThumbDown from '@mui/icons-material/ThumbDown';
import { FillinStatus } from '../../models';
import { ApproveOrDenyDialog } from '..';

const ReprovedButton = ({ ...props }) => {
  const record = useRecordContext()
  const [showDialog, setShowDialog] = useState(false);

  const labelbutton = `${props.label}`;

  const handleClick = (e) => {
    e.stopPropagation();
    setShowDialog(true);
  };

  const closeDialog = () => {
    setShowDialog(false);
  };

  return (
    <Fragment>
      {
        record.status === FillinStatus.blocked &&
        <>
          <ApproveOrDenyDialog open={showDialog} handleClose={closeDialog} status={FillinStatus.reproved} />
          <Button {...props} type="button" label={labelbutton} onClick={handleClick} startIcon={<ThumbDown />} />
        </>
      }
    </Fragment>
  );
}

export default ReprovedButton;